import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import alert from '../../../../assets/images/alert.png';

interface IModalHasEmptyAnswers {
  modalIsOpen: boolean;
  toggleModal: () => void;
  finishQuiz: () => void;
}

export function ModalHasEmptyAnswers({
  modalIsOpen,
  toggleModal,
  finishQuiz,
}: IModalHasEmptyAnswers) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={styles.contents}>
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={alert} alt="" />
        </div>
        <h1 className={styles.title}>
          <b className={styles.highlightText}>Atenção!</b> Têm perguntas sem
          respostas. Tem certeza que deseja prosseguir?
        </h1>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
          }}
          className={styles.btnAgree}
          type="button"
        >
          Voltar a responder
        </button>
        <button
          onClick={async () => {
            toggleModal();
            finishQuiz();
          }}
          className={styles.btnBack}
          type="button"
        >
          Finalizar quiz
        </button>
      </div>
    </Modal>
  );
}
